import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { profileService, type ProfileResponse, type UpdateProfilePayload } from '../services/profile.service';
import { getQueryState, type QueryWithState } from './useQueryWithState';

export const useProfile = (): QueryWithState<ProfileResponse> => {
  const query = useQuery({
    queryKey: ['profile'],
    queryFn: () => profileService.getProfile(),
  });

  return {
    ...query,
    renderState: getQueryState(query),
  };
};

export const useUpdateProfile = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload: UpdateProfilePayload) => profileService.updateProfile(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['profile'] });
      queryClient.invalidateQueries({ queryKey: ['auth', 'user'] });
    },
  });
};
